export { default as IntegrationPage } from '@/views/pages/integration/IntegrationPage.vue';
export { default as IntegrationLogPage } from '@/views/pages/integration/IntegrationLogPage.vue';
export { default as PipedriveIntegrationFormPage } from '@/views/pages/integration/PipedriveIntegrationFormPage.vue';
export { default as OpenAiIntegrationFormPage } from '@/views/pages/integration/OpenAiIntegrationFormPage.vue';
export { default as MoskitIntegrationFormPage } from '@/views/pages/integration/MoskitIntegrationFormPage.vue';
